<template>
    <card-grid-item
        :tab-widget="tabWidget"
        :card-class="['card-grid']"
        :min-w="3"
        :min-h="minHeight"
        :resized="handleResized"
        @tab-widget-settings-click="handleTabWidgetSettingsClick"
    >
        <template v-slot:card-title>
            {{ title }}
        </template>

        <template v-slot:card-body>
            <reservations-card-grid
                :getDataEndpoint="getDataEndpoint"
                :cardGridKey="cardGridKey"
                :limit="limit"
                :tabWidget="tabWidget"
                :hideEnteredColumn="hideEnteredColumn"
            />
        </template>

        <template v-slot:tab-widget-settings-modal>
            <tab-widget-settings-modal-form
                :modal-id="tabWidgetSettingsModalID"
                :update="updateTabWidgetSettings"
                :initial-values="tabWidgetSettingsInitialValues"
                :with-airbnb-reservations="true"
                :with-hide-older-than-days="true"
                @success-update="handleSuccessTabWidgetSettingsUpdate"
                :withTableFontSize="true"
            ></tab-widget-settings-modal-form>
        </template>
    </card-grid-item>
</template>

<script>
    import BusyModal from '../../../generic/busy-modal/busy-modal.vue';
    import CardGrid from '../../../generic/card-grid/card-grid.vue';
    import CardGridItem from './card-grid-item.vue';
    import CardGridItemBase from './card-grid-item-base';
    import { getWidgetGridRowsNumber } from '../helpers';
    import { mapGetters } from 'vuex';
    import ResponsiveButton from '../../../generic/responsive-button/responsive-button.vue';
    import TabWidgetSettingsModalForm from './tab-widget-settings-modal-form.vue';
    import ReservationsCardGrid from './reservations-card-grid.vue';
    import cardGridItemBaseMixin from './card-grid-item-base-mixin';

    export default {
        mixins: [cardGridItemBaseMixin],
        props: {
            getDataEndpoint: {
                type: String,
                required: true,
            },
            tabWidget: Object,
            hideEnteredColumn: Boolean,
        },
        components: {
            BusyModal,
            CardGrid,
            CardGridItem,
            ResponsiveButton,
            TabWidgetSettingsModalForm,
            ReservationsCardGrid,
        },
        data() {
            return {
                limit: getWidgetGridRowsNumber({
                    tabWidget: this.tabWidget,
                }),
            };
        },
        computed: {
            ...mapGetters('header', ['userPermissions']),
            tabWidgetSettingsInitialValues() {
                return {
                    settings: {
                        name: this.tabWidget.settings.name || this.defaultName,
                        display_airbnb_reservations:
                            this.tabWidget.settings.display_airbnb_reservations,
                        hide_older_than_days: this.tabWidget.settings.hide_older_than_days,
                        table_font_size: this.tabWidget.settings.table_font_size || this.defaultWidgetFontSize,
                    },
                };
            },
        },
        methods: {
            handleResized() {
                this.limit = getWidgetGridRowsNumber({
                    tabWidget: this.tabWidget,
                });
                this.cardGridKey += 1;
            },
        },
    };
</script>
